













import { Suggestion } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';

@Component
export default class TermSuggestion extends Vue {
  @Prop({ default: [] })
  suggestion: Suggestion;

  @Prop()
  inCategory: string;

  @Prop()
  selected: boolean;

  @Prop({ default: EVENTS.SuggestionSelected })
  event: string;

  get hasFacets() {
    return this.suggestion.facets && this.suggestion.facets.length;
  }

  selectSuggestion() {
    this.$x.emit(this.event, this.suggestion);
  }

  get ariaSuggestion() {
    if (this.hasFacets && this.inCategory) {
      return `${ this.suggestion.term } ${ this.inCategory } ${ this.suggestion.facets[0].filters[0].title.toLowerCase() }`;
    } else if (this.hasFacets) {
      return `${ this.suggestion.term } ${ this.suggestion.facets[0].filters[0].title.toLowerCase() }`;
    }
    return this.suggestion.term;
  }
}
